$.formUtils.addValidator({
	name : 'date',
	validatorFunction : function(date, $el, conf) {
		if('' != date){
			var dateFormat = 'dd/mm/yyyy';
			if($el.valAttr('format')) {
				dateFormat = $el.valAttr('format');
			} else if( conf.dateFormat ) {
				dateFormat = conf.dateFormat;
			}
			return $.formUtils.parseDate(date, dateFormat) !== false;
		} else {
			// ignore validation if empty
			return true
		}
	},
	errorMessage : '',
	errorMessageKey: 'badDate'
});
